import BrandAdmin from "./BrandAdmin-container";

/**
 * Export the top level component BrandAdmin-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default BrandAdmin;
